import { Spacing } from '@persona-id/design-tokens';
import { CircleInfoIcon } from '@persona-id/design-tokens/icons';
import { VFC } from 'react';
import styled from 'styled-components';

import { WorkflowError } from 'dashboard/models/workflow';
import Banner from 'design-system/components/Banner';
import Spacer from 'design-system/components/Spacer';

const BannerContent = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${Spacing[2]};
  align-items: center;
  gap: ${Spacing[2]};
`;

interface OverrideErrorBannerProps {
  validationError?: WorkflowError | null;
}

const OverrideErrorBanner: VFC<OverrideErrorBannerProps> = ({ validationError }) => {
  if (validationError == null) {
    return null;
  }

  return (
    <>
      <Spacer height={1} />
      <Banner variant='alert'>
        <BannerContent>
          <CircleInfoIcon />
          {'field' in validationError
            ? 'Please configure all required fields'
            : validationError.message}
        </BannerContent>
      </Banner>
      <Spacer height={1} />
    </>
  );
};

export default OverrideErrorBanner;
